import { render, staticRenderFns } from "./StockBlock.vue?vue&type=template&id=05adcd0f&scoped=true&"
import script from "./StockBlock.vue?vue&type=script&lang=js&"
export * from "./StockBlock.vue?vue&type=script&lang=js&"
import style0 from "./StockBlock.vue?vue&type=style&index=0&id=05adcd0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adcd0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VContainer})
